module.exports = __webpack_public_path__ + "img/apphub_logo.279ce478.png";